// Evidence Parts Lookup Table - Name to Display Title mapping
// Auto-generated from userPrograms.json

export const evidencePartsLookup: Record<string, string> = {
  " Clinical": "Clinical",
  Clinical: "Clinical",
  " Practice Assessment Document": " Practice Assessment Document (85MB limit / file)",
  "Practice Assessment Document": " Practice Assessment Document (85MB limit / file)",
  "20 questions": "20 questions",
  "6, 12 and 18-month reviews": "6, 12 and 18-month reviews",
  "Activity Duration": "Activity duration",
  "Activity description": "Activity description",
  "Activity duration": "Activity duration",
  ActivityReflection: "Reflect on your activity",
  ActivityReflectionOptional: "Reflect on your activity",
  "Additional evidence": "Additional evidence",
  AdditionalSupport: "Do you feel you would benefit from any additional support at present? ",
  AdministrationTickboxes: "Administration",
  "Advanced Certificate":
    "Upload your Advanced Certificate as evidence of completion of this course (85MB limit / file)",
  "Adverse Features Observed": "Adverse Features Observed",
  "AirWay Management Techniques": "Airway Management Techniques",
  AllDocsRead: "Confirm",
  AlternativeEvidenceConfirmTickbox:
    "I confirm that this evidence will form part of my Portfolio and that this has been agreed with my NQP lead.",
  "Any adverse features?": "Any adverse features?",
  "Any complications?": "Any complications? If yes, please describe complication below.",
  "Approved By": "Final sign off all approve completed.",
  "Are there any particular reflections in your Portfolio that stand out? Has your practice changed following any of these reflections?":
    "Are there any particular reflections in your Portfolio that stand out? Has your practice changed following any of these reflections?",
  "Are you eligible for Fast Track? ": "Are you eligible for Fast Track? ",
  Area: "Area",
  "Area of practice 1 - pre-preceptorship": "Area of practice 1 - pre-preceptorship",
  "Area of practice 2 - pre-preceptorship": "Area of practice 2 - pre-preceptorship",
  "Areas for Reflection ": "Select Areas for Reflection ",
  "Areas for Reflection CHUB": "Select Areas for Reflection ",
  "Areas for Reflection CSM": "Select Areas for Reflection ",
  AssignmentNumber: "Assignment number",
  "Attachment Optional": "Supporting Attachment",
  Attachments: "Relevant documents (150MB limit / file)",
  "Attachments - Mandatory": "Relevant documents (85MB limit / file)",
  "BLTickBox Exception": "I have completed my CERAD blue light driving course",
  "Banner Calls": "ATTENTION: Mentee: evidence parts below this box must be filled out by your mentor.",
  "Banner Calls no patient identifiable information":
    "ATTENTION: You must ensure that all evidence contains no patient identifiable information",
  "Banner handover": "ATTENTION: evidence parts below this box must be filled out by your mentor.",
  Bases: "Base",
  Benefits: "Benefits",
  BluelightApproval: "Blue Light Approval",
  BookDate: "Date",
  "CAD / Case ID": "CAD / Case ID",
  "CAD number": "CAD number",
  "CERAD-No": "Exception reason",
  "CPD Activity - HART and EPRR": "CPD Activity",
  "CPD pdf": "Upload a copy of your 'My Performance & Wellbeing Conversation - SWAST CPD'  pdf",
  "Call Information / Present Complaint": "Call Information / Present Complaint",
  "Call sign": "Call sign",
  CharlieBloeCourseCert: "Course Certificate (PDF, Image, etc.)",
  CharlieBloeCourseConfirm: "Confirm",
  CharlieBloeCourseFeedback: "Course Feedback",
  "Clinical Education Policies ": "Clinical Education Policies ",
  "Clinical Support Type": "Clinical Support Type",
  "Clinical Support Type Other text box": "If your Clinical Support Type is not listed above, please specify here",
  ClinicalSupervisionForm: "Clinical Supervision Form (CSF)",
  ClinicalTickboxes: "Clinical",
  "Clinician Comments": "Clinician comments",
  CoLBanner:
    "Please document a summary of any feedback you would like to share with the NQP and any recommendations for future development through the NQP programme. If the NQP or line manager needs to take any action, this may need to be communicated via email too. Similarly, if further support is required please complete a Learning and Development referral. ",
  Comments: "Comments",
  "Comments and reflection": "Provide any relevant comments and reflections",
  "Comp Selector": "Learning Outcomes",
  CompletionDate: "Completion date",
  Comps: "Standards",
  Condition: "Condition",
  "Confidence level 1": "Confidence level. 1 = Not confident - 5 = Very confident",
  "Confidence level 2": "Confidence level. 1 = Not confident - 5 = Very confident",
  "Confidence level Text Box": "How will you develop your skills and confidence?",
  "Confidence level banner":
    "The two areas of practice are those you choose in the 0-6 months progress check. These are to help you track your confidence levels and reflect on your progress. You cannot change the areas of practice once added.",
  "Correct Advice": "Correct Advice",
  "Correct Discriminator Selected": "Correct Discriminator Selected",
  "Correct Disposition / Outcome": "Correct Disposition / Outcome",
  "Correct Documentation": "Correct Documentation",
  "Correct MTS Card Selection": "Correct MTS Card Selection",
  "Course Certificate": "Upload your course certificate if you have one",
  CredBanner:
    "Indicates Credentialing to NQP2 if completed 35% Portfolio and Completed Blue Light driving course where no exceptions are met. Only able to complete at 6 month mark, or 3 Months If NQP via University of Cumbria Apprenticeship",
  CredConfirmer: "I confirm the credentials/accreditation to NQP2",
  "Custom tags": "Custom tags",
  Date: "Date",
  "Date of Call": "Date of Call",
  "Date of Incident": "Date of incident",
  "Date of Reflection": "Date of reflection",
  "Date of Shift": "Date of shift",
  "Date of activity": "Date of activity",
  "Date of entry ": "Date of entry",
  "Date of observation": "Date of observation",
  "Date of reflection": "Date of reflection",
  "Date of shift": "Date of shift",
  "Did the CSM follow or consult the relevant policy or document?":
    "Did the CSM follow or consult the relevant policy or document?",
  "Did the CSM gather the relevant information (probing) and act in a timely manner?":
    "Did the CSM gather the relevant information (probing) and act in a timely manner?",
  "Did the CSM provide advice in a non-confrontational and/or educational way?":
    "Did the CSM provide advice in a non-confrontational and/or educational way?",
  "Did the CSM understand the question and the context/situation?":
    "Did the CSM understand the question and the context/situation?",
  "Did the patient receive warming? If so, by what method?": "Did the patient receive warming? If so, by what method?",
  "Did you feel supported?": "Did you feel supported?",
  "Did you have a distal pulse after the relocation/realignment?":
    "Did you have a distal pulse after the relocation/realignment?",
  "Did you have a distal pulse before relocation/realignment?":
    "Did you have a distal pulse before relocation/realignment?",
  "Differential diagnoses": "Differential diagnoses",
  Discussion: "Discussion",
  "Discussion topic": "Discussion topic",
  DiscussionBanner:
    "This section can be used to document any discussions or clinical supervision that takes place, as these can also be used to demonstrate learning objectives. For example, you may discuss NQP portfolio progress, a recent clinical experience or CPD activities. Similarly, if you do not attend many incidents today you may be able to capture learning objectives through a professional discussion. ",
  "Do you have any feedback on the NQP process and / or on Sector support?":
    "Do you have any feedback on the NQP process and / or on Sector support?",
  "Do you require any support?": "Do you require any support?",
  "Driscoll1 What? ": "What? (Descriptive phase)",
  "Driscoll2 So what?": "So what? (Analysis)",
  "Driscoll3 Now what?": "Now what? (Action plan)",
  "ESR of Manager": "ESR of Manager",
  "ESR of Tutor": "ESR of Tutor/Manager/Mentor",
  EducationDaysBanner:
    "Please document a summary of the content on your education day and reflect on what you have learnt.",
  "End Of Course Feedback": "End of course comments",
  "Enhanced care": "Enhanced care",
  EnhancedCareCourseCert: "Course Certificate (PDF, Image, etc.)",
  EnhancedCareCourseConfirm: "Confirm",
  EnhancedCareCourseFeedback: "Course Feedback",
  "Entry Type": "Enter the type of case encountered.",
  "Entry summary": "Entry summary",
  EquipmentAndVehiclesTickboxes: "Equipment and Vehicles",
  "Essay Approved": "Confirmation tickbox",
  EssayBanner: "This can only be uploaded once your NQP Lead has confirmed the essay is passed",
  "Evidence of putting this CPD activity into practice": "Evidence of putting this CPD activity into practice",
  EvidenceType: "Type",
  EvidenceTypeOther: "If other, specify type:",
  "Exception reasons": "Exception reasons",
  "FT CPD": "CPD",
  "FT Leadership": "Leadership",
  "FT-A1": "A1. The NQP is able to understand and demonstrate the need for patient advocacy.",
  "FT-A2": "A2. The NQP is able to demonstrate confidence in all aspects of patient examination and history",
  "FT-A2.1":
    "A2. The NQP is able to demonstrate the ability to formulate and implement a management plan in collaboration with the patient, carer and other HCPs.",
  "FT-A3":
    "A3. The NQP is able to recognise clinical risk and understand the need for compliance with clinical governance processes.",
  "FT-B1": "B1. The NQP is able to demonstrate professional behaviour in all areas of communication.",
  "FT-B1.2":
    "B1.2. The NQP is able to demonstrate an understanding of the processes involved in reporting concerns about safety and wellbeing.",
  "FT-B2": "B2.The NQP is able to demonstrate the principles of equality and diversity.",
  "FT-B3.1":
    "B3.1. The NQP is able to demonstrate the ability to work within the limits of their own scope of practice and competence.",
  "FT-B3.2":
    "B3.2. The NQP is able to demonstrate the ability to delegate tasks appropriately and understand the issues arising from the supervision of others.",
  "FT-B3.3":
    "B3.3. The NQP is able to demonstrate an awareness of risk and a responsibility to manage risk and seek support where required.",
  "FT-B4.1":
    "B4.1. The NQP is able to demonstrate an open and honest manner during all incidents, adverse or otherwise.",
  "FT-B4.2":
    "B4.2 The NQP is able to demonstrate behaviour that justifies the public’s trust and confidence in the profession and the individual.",
  "FT-B4.3":
    "B4.3 The NQP is able to demonstrate the ability to keep thorough, clear, accurate and secure work records.",
  "FT-B4.4":
    "B4.4 The NQP is able to identify and address ethical and legal issues that may occur during their practice and work within a strong ethical framework.",
  "FT-C1": "C1. The NQP is able to demonstrate a continuing high standard of CPD.",
  "FT-D1":
    "D1. The NQP is able to demonstrate leadership and judgement in making informed decisions and to take ownership of their own learning and development.",
  "FT-D2": "D2. The NQP is able to demonstrate a team working ethos.",
  "FT-E1":
    "E1. The NQP is able to evidence a practical understanding of the role and responsibilities of the mentor (Practice Educator) in a clinical setting.",
  "FT-F1":
    "F1. The NQP is able to demonstrate an understanding of the requirement to manage their own fitness to practice and an awareness of the appropriate support mechanisms that exist within their Trust.",
  "FT-G1":
    "G1. The NQP is able to demonstrate insight into their own professional and clinical practice by using reflective models.",
  "FT-Mentor-Q1": "The candidate meets the requirements of the 6 month NQP review",
  "FT-Mentor-Q2":
    "The candidate is up to date with all relevant statutory and mandatory training as required by Trust policy.",
  "FT-Mentor-Q3":
    "Does the candidate have any formal disciplinary, absence or performance management action against the candidate or are there any actions pending",
  "FT-Mentor-Q4": "Do you have any further comments regarding this application?",
  "FT-Q1": "Please provide details of prior experience of mentoring in a clinical setting ",
  "FT-Q2":
    "Please provide evidence that you are aware and have followed national and local trust policy and the Standard Operating Procedures relevant to the NQP role",
  "FT-Q3": "Please confirm that all relevant statutory and mandatory training is up to date.",
  "FT-Q4": "Do you have any further comments regarding this application?",
  FTPanelTickBox: "Panel Approval has been received!",
  "Fast Track Mentor Checklist": "Guidance notes",
  FastTrack: "Confirm",
  FastTrackComments: "Additional Fast Track info",
  FastTrackSelfAssessment1: "The NQP is able to understand and demonstrate the need for patient advocacy.",
  FastTrackSelfAssessment10:
    "The NQP is able to demonstrate an awareness of risk and a responsibility to manage risk and seek support where required.",
  FastTrackSelfAssessment11:
    "The NQP is able to demonstrate an open and honest manner during all incidents, adverse or otherwise.",
  FastTrackSelfAssessment12:
    "The NQP is able to demonstrate behaviour that justifies the public's trust and confidence in the profession and the individual.",
  FastTrackSelfAssessment13:
    "The NQP is able to demonstrate the ability to keep thorough, clear, accurate and secure work records.",
  FastTrackSelfAssessment14:
    "The NQP is able to identify and address ethical and legal issues that may occur during their practice and work within a strong ethical framework.",
  FastTrackSelfAssessment15: "The NQP is able to demonstrate a continuing high standard of CPD.",
  FastTrackSelfAssessment16:
    "The NQP is able to demonstrate leadership and judgement in making informed decisions and to take ownership of their own learning and development.",
  FastTrackSelfAssessment17: "The NQP is able to demonstrate a team working ethos.",
  FastTrackSelfAssessment18:
    "The NQP is able to evidence a practical understanding of the role and responsibilities of the mentor (Practice Educator) in a clinical setting.",
  FastTrackSelfAssessment19:
    "The NQP is able to demonstrate an understanding of the requirement to manage their own fitness to practice and an awareness of the appropriate support mechanisms that exist within their Trust.",
  FastTrackSelfAssessment2:
    "The NQP is able to demonstrate confidence in all aspects of patient examination and history taking in accordance with the medical model.",
  FastTrackSelfAssessment20:
    "The NQP is able to demonstrate insight into their own professional and clinical practice by using reflective models.",
  FastTrackSelfAssessment3:
    "The NQP is able to demonstrate the ability to formulate and implement a management plan in collaboration with the patient, carer and other HCPs.",
  FastTrackSelfAssessment4:
    "The NQP is able to recognise clinical risk and understand the need for compliance with clinical governance processes.",
  FastTrackSelfAssessment5: "The NQP is able to demonstrate professional behaviour in all areas of communication.",
  FastTrackSelfAssessment6:
    "The NQP is able to demonstrate an understanding of the processes involved in reporting concerns about safety and wellbeing.",
  FastTrackSelfAssessment7: "The NQP is able to demonstrate the principles of equality and diversity.",
  FastTrackSelfAssessment8:
    "The NQP is able to demonstrate the ability to work within the limits of their own scope of practice and competence.",
  FastTrackSelfAssessment9:
    "The NQP is able to demonstrate the ability to delegate tasks appropriately and understand the issues arising from the supervision of others.",
  FastTrackTickBox: "NQP has Fast Tracked",
  Feedback: "Feedback",
  FeedbackForEL: "Feedback For EL",
  FeedbackForELBanner:
    "Please provide some feedback for your Education Lead. They will be able to see this in order to make CoL shifts as useful and supportive as possible.",
  "Final Pain Score": "Final Pain Score (Out of 10)",
  "For operational intubations only: What was your indication for intubation?":
    "For operational intubations only: What was your indication for intubation?",
  "For simulations please provide ESR No. of witness": "For simulations please provide ESR No. of witness",
  "For simulations please provide ESR No. of witness - Intubation": "For simulations please provide ESR No. of witness",
  "Four Pillars Evidence Of Engagement":
    "Where the clinician is an ACP is there evidence of engagement within all four pillars of practice?",
  FrackTrackUsed: "Frack Track Used",
  "General Confidence level": "General / Overall confidence level",
  "Gibbs1 Description": "Description:",
  "Gibbs2 Feelings": "Feelings:",
  "Gibbs3 Evaluation": "Evaluation:",
  "Gibbs4 Analysis": "Analysis:",
  "Gibbs5 Conclusion": "Conclusion:",
  "Gibbs6 Action Plan": "Action Plan:",
  GovernanceTickbox: "Confirm",
  "HCPC Number": "HCPC number",
  HCPC1: "What event or topic are you reflecting on?",
  HCPC2: "Would you call this a positive or challenging event?",
  HCPC3: "What happened?",
  HCPC4: "Looking back",
  HCPC5: "Looking forward",
  "HP Policies": "HP Policies ",
  HandBackBanner: "ATTENTION: Mentor: hand the device back to your mentee once you have completed your sections.",
  HandOverBanner:
    "ATTENTION: evidence parts below this box must be filled out by your preceptor. Pass them your device.",
  Handback: "MENTOR: Hand the device back to your mentor once you have completed your sections.",
  "Has met all the criteria": "Has met all the criteria",
  HealthAndWellbeing: "Thinking about your health and wellbeing, how do you currently feel?",
  HealthAndWellbeingTickboxes: "Health and Wellbeing",
  "Hours of shift": "Activity duration",
  "How many attempts did you take to realign/relocate limb?":
    "How many attempts did you take to realign/relocate limb?",
  "How will you apply the learning from this event or webinar to enhance your clinical practice?":
    "How will you apply the learning from this event or webinar to enhance your clinical practice?",
  HowAreYouBanner: "How are you?",
  "Huddle number": "Huddle number as given by your manager, format 'NumberYear' e.g. 125, 225... ",
  "I have completed the session": "Confirm",
  "IRMER Attachments": "Attachments",
  "IRMER Skip": "‘N/a field’ (for SPs who may not need this)",
  "If other, please specify": "If other, please specify",
  "If other, please specify - 2": "If other, please specify",
  "Incident Number": "Incident Number",
  "Incident Outcome": "What was the outcome of the action or intervention? ",
  "Incident Reflection": "Reflection",
  "Incident description": "Incident description",
  "Incident details": "What was the context or setting of the situation being observed? ",
  "Incident number on EPRF": "Incident number on EPRF",
  "Incident number or exercise name": "Incident number or exercise name if applicable",
  "Incident numberPE": "Incident number",
  "Incident/PRF Number": "Incident Number",
  IncidentDescription: "Brief description of case",
  IncidentsBanner:
    "Please use the boxes to complete this section based on each incident that you attend. The sections are broken down to reflect the chronology of the incident and to encourage discussion about differential diagnoses. This will help to promote clinical deductive reasoning and reduction of bias.",
  "Indication (Ketamine Analgesia)": "Indication",
  "Indication (Lyoplas Administration)": "Indication",
  "Indication (Penthrox)": "Indication",
  "Indication (Surgical Airway)": "Indication",
  "Indication (Thoracostomy)": "Indication",
  InductionConfirm: "I have completed my NQP Induction training.",
  InductionThoughtsComments: "Inductions thoughts and comments",
  "Initial Dose": "Initial Dose",
  "Initial Pain Score": "Initial Pain Score (Out of 10)",
  "Interim diagnoses": "Initial diagnoses",
  Introductions: "Activity Description",
  "Intubation Type": "Type of event",
  IntubationIncidentNumber: "Incident Number",
  IntubationIncidentSuccessful: "Was intubation successful?",
  IntubationIncidentSuccessfulComments: "What happened?",
  IntubationReflection: "CPD Learning and Reflection",
  IntubationSimulationObserved: "Was the simulation observed by another clinician?",
  IntubationSimulationProcedure:
    "I confirm that I performed the correct procedure process during simulation and confirmed accurate tube placement",
  IntubationSimulationWitness: "Who witnessed the simulation?",
  IntubationSimulationWitnessRole: "What was their role?",
  "Is eligible for Fast track? ": "May be eligible for Fast track? ",
  "JESIP Collocating": "Co-Locating",
  "JESIP Communicating": "Communicating",
  "JESIP Coordinating": "Coordinating",
  "JESIP JDM": "Joint Decision Making",
  "JESIP Jointly understanding risk": "Jointly understanding risk",
  "JESIP Shared situation awareness": "Shared situation awareness",
  "Job Incident ": "Job Incident ",
  "Klob1 Concrete Experience:": "Concrete Experience:",
  "Klob2 Reflective Observation": "Reflective Observation:",
  "Klob3 Abstract Conceptualization": "Abstract Conceptualization:",
  "Klob4 Active Experimentation": "Active Experimentation:",
  "LDR conclusion summary": "CoL conclusion summary",
  LLDate: "Learning Loop date",
  "Learning / Exercise Objectives": "Learning / Exercise Objectives",
  LearningObjectivesTickboxes: "Learning Objectives / Learning Outcomes / Capabilities",
  "LearningObjectivesTickboxes Optional": "Learning Objectives / Learning Outcomes / Capabilities",
  LearningOutcomes: "Learning Outcomes",
  Limitations:
    "Limitations - What are the potential challenges to implementation personally? How will you influence the sustainability of the initiative?",
  LOs: "PCKUs / Learning Outcomes",
  "METHANE Access and egress": "Access and egress",
  "METHANE Emergency Service (on scene or required)": "Emergency Service (on scene or required)",
  "METHANE Exact Location": "Exact Location",
  "METHANE Hazard": "Hazard",
  "METHANE Major incident": "Major incident",
  "METHANE Number of casualties (and type)": "Number of casualties (and type)",
  "METHANE Type of Incident": "Type of incident",
  "MTS Card": "MTS Card number",
  "MTS Card number": "MTS Card number",
  "Manager completing the review": "Manager completing the review",
  MedicinesAndControlledDrugsTickboxes: "Medicines and Controlled Drugs",
  "Mentee Name": "NQP",
  MenteeInfo: "NQP Information",
  "Mentor ESR Number": "Mentor ESR Number",
  "Mentor Information": "Mentor Information",
  "Mentor Name": "Mentor Name",
  MentorComments: "Preceptor Comments",
  MentorCourseCert: "Upload your Mentorship course certificate if you have one",
  MentorCourseConfirm: "Confirm",
  MentorCourseFeedback: "Mentorship online module feedback",
  MentorCourseInfo: "Course Information",
  MentorTicks:
    "Your mentor agrees that you have successfully completed your first 12 months of your NQP portfolio. You can now submit this Progress Check for approval.",
  "Mentoring Comments": "Comments on mentoring",
  "Mentoring qualification": "Mentoring qualification",
  MentoringLogConfirmation: "Confirmation",
  "Mentorship course attachment": "Mentorship course attachment (pdf, word, etc)",
  "Mentorship course feedback": "Mentorship course feedback",
  MentorshipCourseConfirm: "Mentorship Course Confirm",
  "Milestone Review Attachments": "Upload your review PDF (85MB limit / file)",
  MilestoneReviewBanner:
    "In order to satisfy this Milestone review, please ensure that you have uploaded a copy of your completed annual Appraisal document. ",
  MilestoneReviewPaperwork: "Milestone Review Paperwork",
  "Minimum Requirements":
    "Has the clinician met the minimum requirements of the revalidation portfolio over the past 12 months?",
  "Misc. Documents ": "Misc. Documents ",
  "Misc. Policies ": "Misc. Policies ",
  ModelSelector: "Reflective Model Selector",
  "NEAS IC JESIP": "Evidence use of JESIP Principles",
  "NEAS IC METHANE": "Record METHANE message here if relevant",
  "NEAS IC Type": "Type",
  "NOS Select": "National Occupational Standard",
  "NQP HCPC first registration": "NQP HCPC first registration date",
  "NQP HCPC number": "NQP HCPC number",
  "NQP comments": "NQP comments",
  NQPDocumentationTickBoxes: "NQP Documentation",
  "NWAS IC JESIP": "Evidence use of JESIP Principles",
  "NWAS IC METHANE": "Record METHANE message here if relevant",
  "NWAS IC Type": "Type",
  "Name of Manager": "Name of Manager",
  "Name of Tutor": "Name of Tutor/Manager/Mentor",
  "Name of person who observed": "Name of person who observed",
  "Name of reviewer": "Name of reviewer",
  NeuroBanner:
    "We recognise that neurodiversity is a natural and valuable part of human diversity and seeks to foster an inclusive and respectful environment where all individuals can thrive.",
  NeurodiverseTextBox: "Is there anything you would like to disclosure to your SP about your learning style?",
  NeurodiverseTickBox: "Are you neurodiverse?",
  "Next steps and your 5-year plan: What are you career aspirations?":
    "Next steps and your 5-year plan: What are you career aspirations?",
  "Next steps and your 5-year plan: What are your career aspirations?":
    "Next steps and your 5-year plan: What are your career aspirations?",
  "Now What": "NOW WHAT?",
  "Number of Attempts": "Number of Attempts",
  OCPDeclaration: "OCP Declaration",
  "OO Comment": "OO comments",
  "OO Confirmation": "Confirm",
  Objective: "Objective",
  "Observation Feedback": "Observation feedback",
  "Operation Workplace Review (OWR) & Appraisal ": "Operation Workplace Review (OWR) & Appraisal completed",
  Opportunities:
    "Opportunities - How can you make the most of your preceptorship period? What specific opportunities are there to improve your skills",
  "Other Reflection TextBox": "Reflection",
  Overview: "Overview",
  "PLF name": "PLF name",
  "Pass/Areas for Reflection/Action Required": "Pass/Areas for Reflection/Action Required",
  "Pass/Areas for Reflection/Action Required CHUB": "Pass/Areas for Reflection/Action Required",
  "Pass/Areas for Reflection/Action Required CSM": "Pass/Areas for Reflection/Action Required",
  "Patient Weight (kg)": " Patient Weight (kg) ",
  "Perceptorship Shift Reflection":
    "How has this shift with a Band 6 Paramedic benefited your practice? Were there any areas of identified reflection or improvement in your practice? If so use this box to record this.",
  "Personal Development Plan Attachment": "Personal Development Plan (85MB limit / file)",
  "Personal Development Plan Selector": "Do you have a Personal Development Plan?",
  "Please describe the outcome and follow up care of the patient (e.g. Transferred to hospital, Care passed to Critical Care assets, GP referral, etc).":
    "Please describe the outcome and follow up care of the patient (e.g. Transferred to hospital, Care passed to Critical Care assets, GP referral, etc).",
  "Please give a brief overview of the patient's presenting complaint:":
    "Please give a brief overview of the patient's presenting complaint:",
  "Please give feedback on your overall experience with Lyoplas administration.":
    "Please give feedback on your overall experience with Lyoplas administration.",
  "Please select what analgesia was used during the procedure:":
    "Please select what analgesia was used during the procedure:",
  "Practice-based education (mentoring)": "Practice-based education (mentoring)",
  "Practise Safely":
    "Since your last annual review conversation there has been no change relating to your good character that may affect your ability to practise safely and effectively",
  PreceptorReviewAdditionalComments: "Additional comments / requests",
  PreceptorReviewBanner:
    "NOTE: Once you have booked your face-to-face review, please ensure your evidence is submitted at least 7 days in advance. This allows your SP sufficient time to review the evidence ahead of your meeting.",
  PreceptorReviewDate: "Requested date",
  PreceptorReviewRequest: "I would like to book my Preceptor / NQP one to one please.",
  "Presenting Complaint / Reason for dispatch?": "Presenting Complaint / Reason for dispatch?",
  "Professional practice": "Professional practice",
  "Reflect Banner TL Obs": "Outcome: Reflect on your shift with the TL",
  "Reflect on the audit feedback received and outline the steps you will take to improve your EPRF documentation for this type of clinical presentation.":
    "Reflection",
  "Reflect on the last 6 months of your NQP consolidation period":
    "Reflect on the last 6 months of your NQP consolidation period",
  "Reflect on the last 6 months: How are you getting on?": "Reflect on the last 6 months: How are you getting on?",
  Reflection: "Reflection",
  "Reflection and feedback": "Reflection and feedback",
  ReflectionBanner: "Reflection",
  "Reflections from last the 2 years: What went well? Did you have any difficult incidents or experiences?":
    "Reflections from last the 2 years: What went well? Did you have any difficult incidents or experiences?",
  "Relevant documents": "Relevant documents (85MB limit / file)",
  "Review Feedback": "Review Feedback",
  ReviewActionPlan: "Action Plan",
  ReviewApproval: "Review approval",
  ReviewFeedback: "Review Feedback",
  ReviewRequired: "Is an in-person review required?",
  "Reviewer ESR Number": "Reviewer ESR Number",
  "Role for associate mentor": "Type of person being mentored",
  "Roles Select - HART and EPRR": "Role",
  "Safeguarding Policy & Handbook ": "Safeguarding Policy & Handbook ",
  "Select Areas for Reflection": "Select Areas for Reflection ",
  "Select Areas for Reflection ": "Select Areas for Reflection ",
  "Senior Paramedic completing the review": "Senior Paramedic completing the review",
  "Shift TBC. e.g. 19-07, 15-03 are these dates": "Shift",
  ShiftCompletionRecord: "Record of shift completion",
  ShiftLogAttachments: "Relevant documents",
  ShiftLogFeedback:
    "What feedback did you receive during this shift, including both positive comments and constructive suggestions for improvement?",
  ShiftLogReflection1: "What aspects of today's shift do you feel went well?",
  ShiftLogReflection2: "What areas for development have you identified through self-reflection?",
  ShiftLogReflection3:
    "Can you describe a particular incident or experience during your practice where you felt you learned something significant? ",
  ShiftWithSPCCBanner: "Add your reflections and comments on this shift.",
  ShiftWithSPUCBanner: "Add your reflections and comments on this shift.",
  ShowCARE:
    "How do you show Compassion, Accountability & responsibility, Respect, and Excellence in innovation, i.e. that you “CARE”, at work?",
  SignOffTick: "The NQP has completed successfully",
  "Signature box for the observer to sign": "Signature box for the observer to sign",
  SirenConfirm: "Siren documents confirmation",
  SkillReflection: "Rationale",
  "Skills Used": "Skill used",
  SkillsOther: "Specify skill",
  SkillsSelect: "Skills used",
  "So What": "SO WHAT?",
  "Standard 3": "Standard 3 – How will this CPD contribute to the quality of my practice & service delivery?",
  "Standard 4": "Standard 4 – How will this activity benefit the service user?",
  StartPoint: "I have am ready to start!",
  StartPointBanner:
    "Please document any additional NQP details as well as ideas, concerns and expectations discussed at the beginning of your shift together. ",
  StartPointInfo: "Start point information",
  Strengths:
    "Strengths - What are the drivers for this change in your organisation? What can you contribute to moving this agenda forward?",
  "Successful - Intubation": "Successful? If no, please comment below.",
  "Successful?": "Successful?",
  "Summary Of Learning": "Summary Of Learning",
  "Supervisor Comments": "Supervisor comments",
  "Supervisor ESR": "Supervisor ESR number",
  "Supervisor Name": "Supervisor name",
  SupportForEDI: "What are you doing to support our commitment to equality, diversity, and inclusion? ",
  "Supporting evidence": "Upload any supporting evidence (150MB limit / file)",
  "Surgical Airway Type": "Surgical Airway Type",
  "TL Shift Confidence Levels": "Confidence level",
  "TL-one-to-one request":
    "I have completed my evidence for the last 6 months' Progress check and would like to book my Team Leader / NQP one to one please.",
  "TP Policies": "TP Policies ",
  "Tasking type or training": "Tasking type or training",
  "Thoracostomy Type": "Type of event",
  ThoracostomyIncidentChallenges: "What complications or challenges did you experience?",
  ThoracostomyIncidentChallengesOther: "Other challenges",
  ThoracostomyIncidentClinicalAssessment:
    "What was the clinical assessment of the lung at time of intervention (finger examination)?",
  ThoracostomyIncidentComplications: "Did you identify any complications or challenges while performing thoracostomy?",
  ThoracostomyIncidentIndication: "Indication for thoracostomy",
  ThoracostomyIncidentNumber: "Incident Number",
  ThoracostomyIncidentPatientAge: "Patient Age (approximate)",
  ThoracostomyIncidentProcedureEffective: "Was the procedure effective (i.e. enter the pleuritic space)",
  ThoracostomyReflection: "CPD Learning and Reflection",
  ThoracostomySimulationObserved: "Was this simulation observed by another clinician?",
  ThoracostomySimulationObserver: "Who witnessed the simulation?",
  ThoracostomySimulationSignOff: "Was this simulation your 12-month sign-off with CSM or CP?",
  ThoracostomySimulationSignOffName: "Name of the CSM/CP",
  Threats:
    "Threats - Are there any obstacles that you face? For example, time restraints or learning barriers? Try to be open and honest so your Preceptor can assist you to overcome these.",
  TimeOfIncident: "Time",
  Title: "Title",
  TopAttentionBanner: "ATTENTION: You must ensure that all evidence contains no patient identifiable information",
  "Topic of discussion ": "Topic of discussion ",
  "Total Dose": "Total Dose",
  "Tutor Name": "Tutor Name",
  TutorName: "Tutor Name",
  TutorialRecordForm: "Tutorial Record (CL)",
  "Type of Event": "Type of event",
  "Type of Laryngoscope Used": "Type of Laryngoscope Used",
  "Upload supporting document Mand": "Upload supporting document",
  UploadDocument: "Upload document",
  "Validation Log Selector": "Do you have a Validation Log?",
  ValidationLogComment: "Comment on Validation Log",
  ValidationLogUpload: "Upload your Validation Log PDF (85MB limit / file)",
  "Was minimum monitoring used?": "Was minimum monitoring used?",
  "Was the advice provided within the CSM's scope of practice?":
    "Was the advice provided within the CSM's scope of practice?",
  "Was the clinical support safe and effective?": "Was the clinical support safe and effective?",
  "Was the injury open or closed?": "Was the injury open or closed?",
  "Was the pain relief used sufficient?": "Was the pain relief used sufficient?",
  "Was there a clearly formulated plan understood by both parties?":
    "Was there a clearly formulated plan understood by both parties?",
  "Was there any delay in the administration of Lyoplas? (If yes, please provide further details)":
    "Was there any delay in the administration of Lyoplas? (If yes, please provide further details)",
  "Was there any other delay on scene? (e.g. Issues with extrication, lack of transporting resources, etc.) If yes, please provide further details.":
    "Was there any other delay on scene? (e.g. Issues with extrication, lack of transporting resources, etc.) If yes, please provide further details.",
  WellBeingUpload: "Upload a image of your Well Being status",
  "Wellbeing and resilience": "Wellbeing and resilience",
  WellbeingConversation: "Wellbeing Conversation",
  "Were correct details documented?": "Were correct details documented?",
  "Were the realignment/relocation attempts successful?": "Were the realignment/relocation attempts successful?",
  What: "WHAT?",
  "What Grade of View": "What Grade of View",
  "What aspects of the professional discussion will you apply to enhance your future clinical practice?":
    "What aspects of the professional discussion will you apply to enhance your future clinical practice?",
  "What do you need to work on?": "What do you need to work on?",
  "What evidence do you need to gather over the next 6 months? ":
    "What evidence do you need to gather over the next 6 months? ",
  "What evidence do you need to provide by the end of 12 months?":
    "What evidence do you need to provide by the end of 12 months?",
  "What evidence do you need to provide by the end of 18 months?":
    "What evidence do you need to provide by the end of 18 months?",
  "What evidence do you need to provide by the end of 24 months?":
    "What evidence do you need to provide by the end of 24 months?",
  "What evidence do you need to provide by the end of 6 months?":
    "What evidence do you need to provide by the end of 6 months?",
  "What key insights or knowledge did you gain from this event or webinar?":
    "What key insights or knowledge did you gain from this event or webinar?",
  "What key learning points were identified during the professional discussion?":
    "What key learning points were identified during the professional discussion?",
  "What learning needs have you identified?": "What learning needs have you identified?",
  "What other analgesia was given in conjunction with Ketamine Analgesia?":
    "What other analgesia was given in conjunction with Ketamine Analgesia?",
  "What other analgesia was given in conjunction with Penthrox?":
    "What other analgesia was given in conjunction with Penthrox?",
  "What time did you administer the first dose of Lyoplas?": "What time did you administer the first dose of Lyoplas?",
  "What was the injury site?": "What was the injury site?",
  "What was your motivation for attending this event or webinar?":
    "What was your motivation for attending this event or webinar?",
  "What went well": "What went well?",
  WhatAreYouProudOf: "What are you most proud of?",
  "Where Benzodiazepines required to manage these adverse features?":
    "Where Benzodiazepines required to manage these adverse features?",
  "Which side of chest?": "Which side of chest?",
  "Who did you discuss this with? (name and role)": "Who did you discuss this with? (name and role)",
  "Who observed": "Who observed",
  "Why was Penthrox used over other analgesia's?": "Why was Penthrox used over other analgesias?",
  WorkDeclaration: "Work Declaration",
  "Working with": "Working with",
  WoundCareLiveClosure: "Was the closure method successful?",
  WoundCareLiveCohortLearning: "Was there any learning that could be used by the whole cohort?",
  WoundCareLiveComplications: "Where there any complications?",
  WoundCareLiveIncidentNumber: "Incident Number",
  WoundCareLiveIndividualLearning: "Was there any learning individually?",
  WoundCareLivePatientAge: "Patient age",
  WoundCareLivePatientDisposition: "What was the patient disposition?",
  WoundCareLivePatientSkinIntegrity: "Patient skin integrity",
  WoundCareSimulationClosure: "What closure method was simulated?",
  WoundCareSimulationType: "What type of simulation?",
  WoundCareSimulationWitness: "Who was the witness?",
  WoundCareType: "Type of event",
  WriteEssay: "Or write your essay in the box below.",
  "Your next 6-month plan": "Your next 6-month plan",
  "Your next 6-months plan": "Your next 6-months plan",
  band6Banner: "Credentialing to Band 6",
  band6Confirmer: "I confirm the credentials/accreditation to Band 6",
  inPerson: "Did you have an in-person review?",
  otherBox: "Other",
};

// Total evidence parts: 496

export const autoLearningOutcomeLegacyKeys = new Set([
  "LOs",
  "Comps",
  "LearningObjectivesTickboxes",
  "LearningObjectivesTickboxes Optional",
  "LearningOutcomesTickboxes",
  "LearningObjectives",
  "LearningOutcomes",
]);
